@if (!item()!.hidden) {
  <li class="nav-item coded-menu-caption">
    <label>{{ item()!.title }}</label>
  </li>
  @for (item of item()!.children; track item) {
    @if (item.type === 'collapse') {
      <app-menu-collapse [item]="item" />
    } @else if (item.type === 'item') {
      <app-menu-item [item]="item" />
    }
  }
}
